import sanityClient from '@sanity/client';

import settings from '../app/settings';

export default sanityClient({
  projectId: settings.api.places.projectId,
  dataset: settings.api.places.dataset,
  // token: settings.api.places.token,
  useCdn: settings.api.places.useCdn,
});
